module.exports = "<!-- Main view/routes wrapper-->\n<router-outlet></router-outlet>\n"